// src/pages/BlitzPay/components/SmsInviteDialog.jsx
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";

export default function SmsInviteDialog({
  open,
  onClose,
  loading,
  onSend,
  inviteName,
  setInviteName,
  invitePhone,
  setInvitePhone,
  inviteAmount,
  setInviteAmount,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ minWidth: 350 }}>
        <Typography variant="h6" gutterBottom>
          Send Payment Link via SMS
        </Typography>

        <TextField
          fullWidth
          label="Creator Username"
          value={inviteName}
          onChange={(e) => setInviteName(e.target.value)}
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Creator Phone"
          value={invitePhone}
          onChange={(e) => setInvitePhone(e.target.value)}
          placeholder="+1 555 123-4567"
          sx={{ mt: 2 }}
        />

        <TextField
          fullWidth
          label="Amount (USD)"
          type="number"
          inputProps={{ min: 1, step: 0.01 }}
          value={inviteAmount}
          onChange={(e) => setInviteAmount(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          sx={{ mt: 2 }}
        />

        <Typography variant="caption" color="textSecondary">
          The creator must <strong>not</strong> already exist in your roster.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSend} disabled={loading}>
          {loading ? "Sending…" : "Send SMS"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
